import React, {memo, Suspense, useMemo} from 'react';
import {RouteLoader} from '@dofleini/security';
import PageLoader from '@/components/PageLoader';
import routes from './routes';
import useCurrentSpace from '@/modules/spacesSetting/hooks/useCurrentSpace';

const MainRouter = () => {
  const {data: space} = useCurrentSpace();
  const defaultRoute = useMemo(() => space?.isRootSpace ? '/admin/spaces' : '/products', [space]);

  return (
    <Suspense fallback={<PageLoader/>}>
      <RouteLoader routes={routes} notfoundRedirect={defaultRoute}/>
    </Suspense>
  );
};

export default memo(MainRouter);
